<script>
import { PROJECT_VERSION } from '@utils/version'
export default {
  props: {
    border: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  data() {
    return {
      projectVersion: PROJECT_VERSION,
    }
  },
}
</script>

<template>
  <v-footer
    absolute
    color="#f2f2f2"
    :class="{ border: 'idoors-v-footer-border' }"
  >
    <v-container fluid class="padding-none">
      <div class="text-caption text-center blue-grey--text text--lighten-2">
        A.T.Works, Inc. iDoorsリザーブ Ver {{ projectVersion }}
      </div>
    </v-container>
  </v-footer>
</template>

<style lang="sass" scoped>
.idoors-v-footer-border
  border-top: 1px solid ccc !important
.padding-none
  padding: 0
</style>
